// Fallback content for the Home page, used whenever no siteContent/home
// Firestore doc exists yet (or it has no published blocks) — mirrors
// exactly what was hardcoded in the section components before the CMS
// existed, so nothing changes visually until an admin actually publishes
// an edit. Block ids are fixed (not random) so this file's own diffs stay
// stable across edits.
import { BLOCK_REGISTRY } from "../blockRegistry";

const HOME_DEFAULT_BLOCKS = [
  { id: "default-home-hero", type: "home-hero" },
  { id: "default-home-packages-intro", type: "home-packages-intro" },
  { id: "default-home-why-book", type: "home-why-book" },
  { id: "default-home-about", type: "home-about" },
  { id: "default-home-testimonials", type: "home-testimonials" },
].map((block) => ({
  ...block,
  fields: BLOCK_REGISTRY[block.type].defaultFields,
}));

export default HOME_DEFAULT_BLOCKS;
